<template>
  <div class="p-5 sparkline">
    <div class="flex items-center text-sm font-medium text-gray-800">
      {{ title }}
    </div>
    <div class="flex items-baseline">
      <div class="text-lg" :style="{ color }">
        {{ value }}
      </div>
    </div>
    <div class="border-b border-gray-300">
      <apex-chart :height="80" type="bar" :options="chartOptions" :series="series" />
    </div>
    <div class="flex justify-between mt-1 text-xs text-gray-500">
      <div>{{ start }}</div>
      <div>{{ end }}</div>
    </div>
  </div>
</template>

<script>
import ApexChart from 'vue-apexcharts'

export default {
  name: 'Chart',

  components: {
    ApexChart
  },

  props: [
    'title',
    'value',
    'color',
    'start',
    'end',
    'series'
  ],

  computed: {
    chartOptions () {
      return {
        ...this.defaultOptions,
        ...this.options
      }
    }
  },

  data () {
    return {
      defaultOptions: {
        chart: {
          sparkline: {
            enabled: true
          }
        },
        colors: [this.color, '#718096'],
        dataLabels: {
          enabled: false
        },
        grid: {
          show: false,
          borderColor: '#cbd5e0'
        },
        stroke: {
          curve: 'straight',
          width: 2
        },
        tooltip: {
          custom: function({series, seriesIndex, dataPointIndex, w}) {
            return ''
          }
        },
        markers: {
          size: 0,
          strokeWidth: 2,
          strokeOpacity: 0,
          hover: {
            size: 3
          }
        }
      }
    }
  }
}
</script>

<style lang="postcss">
  .sparkline {
    .apexcharts-tooltip,
    .apexcharts-tooltip.active,
    .apexcharts-xaxistooltip,
    .apexcharts-xaxistooltip.active {
      @apply hidden;
    }

    .apexcharts-marker {
      @apply transition-none;
    }
  }
</style>